export const PlayerState = {
  Created: 'created',
  Init: 'init',
  Playing: 'playing',
  Ended: 'ended',
  Error: 'error',
};
